// Component that shows/hides content based on user permissions
import React from 'react';
import { useUserPermissions } from '../../hooks/useUserPermissions';

const PermissionGate = ({ 
  children, 
  permission, 
  level, 
  group, 
  fallback = null, 
  showLoading = true 
}) => {
  const { permissions, loading } = useUserPermissions();

  if (loading && showLoading) {
    return <div>Loading permissions...</div>;
  }

  if (!permissions) {
    return fallback;
  }

  // Check specific permission
  if (permission && !permissions.permissions.includes(permission)) {
    return fallback;
  }

  // Check minimum level
  if (level && permissions.level < level) {
    return fallback;
  }

  // Check specific group
  if (group) {
    console.log(`[PermissionGate] Checking group "${group}"`);
    console.log(`[PermissionGate] User groups:`, permissions.groups);
    console.log(`[PermissionGate] Has group "${group}":`, permissions.groups.includes(group));
    if (!permissions.groups.includes(group)) {
      return fallback;
    }
  }

  return children;
};

export default PermissionGate;
